import { UserRole } from '../enums/user.enum';

export const USER_ROLES: Record<string, string> = {
  [UserRole.ADMIN.toString()]: 'Admin',
  [UserRole.DEVELOPER.toString()]: 'Developer',
};
